import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ContainedButton } from 'components/ContainedButton';
import React from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: any) => ({
  headerContainer: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottomColor: theme.accent.main,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  headerTitle: {
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  text: {
    textTransform: 'none',
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
  icon: {
    fontSize: '16px',
    marginRight: theme.spacing(1.5),
    color: theme.palette.primary.main,
  },
  containerBtns: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(1),
    },
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  }
}));

type HeaderProps = {
  title: string;
  handleAddEntry: () => void;
  handleReviseOrderLedger: () => void;
  loadingRevise: boolean;
};

const Header = ({ title, handleAddEntry, handleReviseOrderLedger, loadingRevise }: HeaderProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      className={classes.headerContainer}
    >
      <Grid item>
        <Typography variant="h5" className={classes.headerTitle}>
          {title}
        </Typography>
      </Grid>
      <Grid className={classes.containerBtns}>
        {isMobile ? (
          <>
            <ContainedButton
              icon="sync"
              iconOnly
              ariaLabel={t('accounting:request-revision')}
              onClick={handleReviseOrderLedger}
              isLoading={loadingRevise}
              disableElevation
              width={44}
              height={44}
            />
            <ContainedButton
              icon="plus"
              iconOnly
              ariaLabel={t('accounting:add-entry')}
              onClick={handleAddEntry}
              disableElevation
              width={44}
              height={44}
            />
          </>
        ) : (
          <>
            <ContainedButton
              text={t('accounting:request-revision')}
              icon="sync"
              size="small"
              onClick={handleReviseOrderLedger}
              isLoading={loadingRevise}
              disableElevation
            />
            <ContainedButton
              text={t('accounting:add-entry')}
              size="small"
              onClick={handleAddEntry}
              disableElevation
              icon="plus"
            />
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default Header;
